import { parseResponse, DataPointsApiResponse } from '@tableau/metrics-engine';
import { Loadable } from '../models/Loadable';
import { LoadableDataPointsById, MetricsDataState, initialState } from '../state/MetricsDataState';
import { MetricsDataAction, MetricsDataActionTypes } from '../actions/ActionTypes';
import { notLoadedData } from '../selectors/selectMetrics';

export const metricsDataReducer = (previousState: MetricsDataState = initialState, action?: MetricsDataAction): MetricsDataState => {
  switch (action?.type) {
    case MetricsDataActionTypes.REQUEST_START: {
      const stateToAdd: LoadableDataPointsById = {};
      const idsToLoad = notLoadedData(previousState.dataPointsById, action.ids);
      idsToLoad.forEach((id) => {
        stateToAdd[id] = Loadable.loading({}) as Loadable<DataPointsApiResponse>;
      });
      return { ...previousState, dataPointsById: { ...previousState.dataPointsById, ...stateToAdd } };
    }
    case MetricsDataActionTypes.REQUEST_SUCCEEDED: {
      const stateToAdd: LoadableDataPointsById = {};
      Object.entries(action.dataPointsById).forEach(([key, value]) => {
        const parsedResponse = parseResponse(value);
        if (parsedResponse.isOk()) {
          stateToAdd[key] = Loadable.loaded(parsedResponse.unwrap());
        } else {
          stateToAdd[key] = Loadable.failed(parsedResponse.unwrapErr().message);
        }
      });
      return { ...previousState, dataPointsById: { ...previousState.dataPointsById, ...stateToAdd } };
    }
    case MetricsDataActionTypes.REQUEST_FAILED: {
      const stateToAdd: LoadableDataPointsById = {};
      Object.entries(action.failuresById).forEach(([key, value]) => {
        stateToAdd[key] = Loadable.failed(value.message, undefined) as unknown as Loadable<DataPointsApiResponse>;
      });
      return { ...previousState, dataPointsById: { ...previousState.dataPointsById, ...stateToAdd } };
    }
    case undefined:
    default:
      return previousState;
  }
};
